import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import store from '@/store/index.js'
import vuetify from '@/plugins/vuetify' 
import { Logger, LoggerFactory } from 'lines-logger'
import ElogMixin from '@/../../coreui/mixins/logMixin'
import mqttMixin from '@/../../coreui/mixins/mqttMixin'
import GenericMixin from '@/mixins/generic.js'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import utils from '@/../../coreui/helpers/utils.js'
// import AsyncComputed from 'vue-async-computed'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import VueSmartWidget from 'vue-smart-widget'
import VueResizeText from 'vue-resize-text'
import ServerTable from '@/../../coreui/components/ServerTable'
import GenericDialog from '@/../../coreui/components/GenericDialog'
import Toasted from 'vue-toasted'
import Vidle from 'v-idle'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
//added for TipTap
import ElementUI from 'element-ui';
import { ElementTiptapPlugin } from 'element-tiptap';
import 'element-tiptap/lib/index.css';
Vue.use(ElementUI);
Vue.use(ElementTiptapPlugin, {
  // lang: "zh",
  // spellcheck: false,
});
// end tiptap
Vue.component('server-table-component', ServerTable)
Vue.component('generic-dialog', GenericDialog)
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)
import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)
// Vue.use(AsyncComputed)
Vue.config.productionTip = false
Vue.mixin(mqttMixin)
Vue.mixin(ElogMixin)
Vue.mixin(GenericMixin)

Vue.use(Loading)
Vue.use(Vidle)
Vue.use(VueSmartWidget)
Vue.use(VueResizeText)
Vue.use(Toasted, {
  position: 'top-right',
  duration: 10000,
  keepOnHover: true,
  theme: 'bubble'
})

// import '@/../../cortex/src/packages/etoaster'
// import '@/../../cortex/src/packages/etoaster/dist/dtoaster.css'
// import EToaster from '@/../../cortex/src/packages/etoaster'
// import ToasterPresets from '@/../../cortex/toast_presets.json' //Your predefined toasts presets (optionally)

// Vue.use(EToaster, {
//   presets: ToasterPresets,
//   position: 'top-right', //toasts container position on the screen
//   containerOffset: '45px', //toasts container offset from top/bottom of the screen
// })
// store.state.log.elog = ElogMixin.methods.elog
Vue.filter('phrasemap', utils.phraseMap)
let factory = new LoggerFactory(1, null)
factory.setLogWarnings(1)
window.logger = factory.getLoggerColor('Cortex', 'blue')
Vue.prototype.logger = window.logger
window.loggerFactory = factory
Vue.prototype.myWindow = window
// import { createRouter, createWebHistory } from "vue-router";

// var router = createRouter({
//   history: createWebHistory(),
//   routes: [],
// });
import router from './router'

window.app = new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
  data: {
    window: {
      width: 0,
      height: 0
    }
  },
	computed: {
		scrollbarTheme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light';
    },
	},
  created() {
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('online', () => this.setOnline())
    window.addEventListener('offline', () => this.setOffline())
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
    },
    warnExit() {
      console.log('backbutton called')
      this.$root.$confirm('Exit Cortex?', 'Use menu buttons on left side for navigation. This will exit Cortex. Exit?', { color: 'red' })
        .then((confirm) => {

        })
    }
  },
}).$mount('#app')


